export default __webpack_public_path__ + "static/media/Karl Dandleton.cbc8680e.jpg";